"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
//
// assets
//
const appsCopy_1 = require("copy/appsCopy");
const malomo_png_1 = __importDefault(require("assets/images/dashboard/apps/malomo.png"));
const shopify_png_1 = __importDefault(require("assets/images/dashboard/apps/shopify.png"));
const klaviyo_png_1 = __importDefault(require("assets/images/dashboard/apps/klaviyo.png"));
const postscript_png_1 = __importDefault(require("assets/images/dashboard/apps/postscript.png"));
const attentive_png_1 = __importDefault(require("assets/images/dashboard/apps/attentive.png"));
const loop_png_1 = __importDefault(require("assets/images/dashboard/apps/loop.png"));
const gorgias_png_1 = __importDefault(require("assets/images/dashboard/apps/gorgias.png"));
const rebuy_png_1 = __importDefault(require("assets/images/dashboard/apps/rebuy.png"));
const status_jpg_1 = __importDefault(require("assets/images/dashboard/apps/status.jpg"));
const junip_jpg_1 = __importDefault(require("assets/images/dashboard/apps/junip.jpg"));
const justuno_png_1 = __importDefault(require("assets/images/dashboard/apps/justuno.png"));
const yotpo_png_1 = __importDefault(require("assets/images/dashboard/apps/yotpo.png"));
const corso_jpg_1 = __importDefault(require("assets/images/dashboard/apps/corso.jpg"));
const sendlane_png_1 = __importDefault(require("assets/images/dashboard/apps/sendlane.png"));
//
// styles
//
const StyledConnectedIcon_1 = require("./StyledConnectedIcon");
const StyledSectionText_1 = require("components/Dashboard/StyledSectionText");
const MalomoText_1 = require("components/Dashboard/MalomoText");
const Flex_1 = require("components/Dashboard/Flex");
const UninstallAppForAdminUserModal_1 = require("./UninstallAppForAdminUserModal");
const UninstallAppForNonAdminUserModal_1 = require("./UninstallAppForNonAdminUserModal");
const StyledAppContainer_1 = require("./StyledAppContainer");
const StyledTextContainer_1 = require("./StyledTextContainer");
const polaris_1 = require("@shopify/polaris");
const context_1 = require("@/common/context");
const modalOptions = {
    UNINSTALL_APP_FOR_ADMIN_USER: 'uninstall-app-for-admin-user',
    UNINSTALL_APP_FOR_NON_ADMIN_USER: 'uninstall-app-for-non-admin-user'
};
const logos = {
    shopify: shopify_png_1.default,
    klaviyo: klaviyo_png_1.default,
    postscript: postscript_png_1.default,
    attentive: attentive_png_1.default,
    loop: loop_png_1.default,
    gorgias: gorgias_png_1.default,
    rebuy: rebuy_png_1.default,
    status: status_jpg_1.default,
    junip: junip_jpg_1.default,
    justuno: justuno_png_1.default,
    yotpo: yotpo_png_1.default,
    corso: corso_jpg_1.default,
    sendlane: sendlane_png_1.default
};
function openLink(url) {
    window.open(url, '_blank');
}
function logoSrc(name) {
    return logos[name] || malomo_png_1.default;
}
const AppModule = ({ app, onUninstall }) => {
    const flags = (0, launchdarkly_react_client_sdk_1.useFlags)();
    const [uninstallAppModalIsActive, setUninstallAppModalIsActive] = (0, react_1.useState)(false);
    const [selectedApp, setSelectedApp] = (0, react_1.useState)(null);
    const { currentUser } = (0, context_1.useCurrentUser)();
    const targetModal = (0, react_1.useMemo)(() => {
        var _a;
        const isAdmin = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) !== null && _a !== void 0 ? _a : false;
        return isAdmin
            ? modalOptions.UNINSTALL_APP_FOR_ADMIN_USER
            : modalOptions.UNINSTALL_APP_FOR_NON_ADMIN_USER;
    }, [currentUser]);
    const handleOpenUninstallAppModal = (0, react_1.useCallback)((target) => {
        setSelectedApp(target);
        setUninstallAppModalIsActive(true);
    }, []);
    const handleCloseUninstallAppModal = (0, react_1.useCallback)(() => {
        setSelectedApp(null);
        setUninstallAppModalIsActive(false);
    }, []);
    // when adding a new feature flag it should match the name of the integration.
    // In some cases where the name is more than one word we may need to do more
    // than just lowercase
    if (flags[app.name.toLowerCase()] === false) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(polaris_1.LegacyCard, { sectioned: true },
            react_1.default.createElement(StyledAppContainer_1.StyledAppContainer, null,
                react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
                    react_1.default.createElement(polaris_1.Thumbnail, { alt: app.name, source: logoSrc(app.name.toLowerCase()) }),
                    react_1.default.createElement(StyledTextContainer_1.StyledTextContainer, null,
                        react_1.default.createElement(StyledSectionText_1.StyledSectionText, { className: 'app-name' }, app.name),
                        react_1.default.createElement(MalomoText_1.MalomoText, { className: 'app-category', gray: true, paragraph: true, small: true }, app.category),
                        app.installed && (react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
                            react_1.default.createElement(StyledConnectedIcon_1.StyledConnectedIcon, null),
                            react_1.default.createElement(MalomoText_1.MalomoText, { className: 'connected', paragraph: true, small: true }, appsCopy_1.appsCopy.appConnected))))),
                react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true }, app.installed ? (react_1.default.createElement(polaris_1.ButtonGroup, null,
                    react_1.default.createElement(polaris_1.Button, { id: 'uninstall-button', onClick: () => (app === null || app === void 0 ? void 0 : app.clientId) && handleOpenUninstallAppModal(app) }, appsCopy_1.appsCopy.uninstall))) : (react_1.default.createElement(polaris_1.Button, { id: 'install-button', onClick: () => openLink(app.installUrl), variant: 'primary' }, appsCopy_1.appsCopy.install))))),
        react_1.default.createElement(UninstallAppForAdminUserModal_1.UninstallAppForAdminUserModal, { active: targetModal === modalOptions.UNINSTALL_APP_FOR_ADMIN_USER &&
                uninstallAppModalIsActive, onClose: handleCloseUninstallAppModal, onUninstall: onUninstall, selectedApp: selectedApp }),
        react_1.default.createElement(UninstallAppForNonAdminUserModal_1.UninstallAppForNonAdminUserModal, { active: targetModal === modalOptions.UNINSTALL_APP_FOR_NON_ADMIN_USER &&
                uninstallAppModalIsActive, onClose: handleCloseUninstallAppModal, onUninstall: onUninstall, selectedApp: selectedApp })));
};
exports.default = AppModule;
